module.exports = __webpack_public_path__ + "static/media/c31dddea-b1c4-49e0-ab46-6ba357761772.7a4ebc38.JPG";